export default __webpack_public_path__ + "static/media/pexels-thirdman-5327921.e578d6f0.jpg";